module.exports = __webpack_public_path__ + "static/media/about_part3.0a7aa6c8.png";